import {
  InputNumber as AntInputNumber,
  InputNumberProps,
} from "@basic-components";
import { getThousandth } from "@hooks/userToLocale";

export const InputIntegerNumber = ({
  label = '',
  isView,
  value,
  prefix,
  suffix,
  min = 0,
  max,
  ...rest
}: { label: string; isView?: boolean; prefix?: string; suffix?: string; min?: number; max?: number } & InputNumberProps) => {

  const formatNumber = (num: any) => {
    if (prefix && prefix === '￥') {
      return `${ prefix || '' }${ getThousandth(num) }`;
    } else {
      return num;
    }
  };

  if (isView) return value !== undefined && value !== null && value !== ''
    ? `${ formatNumber(value) } ${ suffix || '' }`
    : '--';

  const { onChange, ...restProps } = rest as any;
  const handleChange = (value: any) => {
    let nextValue = value;
    if (typeof value === "string" && /^\d+$/.test(value)) {
      nextValue = Number(value);
    }
    onChange?.(nextValue);
  };

  return (
    <AntInputNumber
      value={value}
      placeholder={`请输入${ label }`}
      {...restProps}
      onChange={handleChange}
      step={1}
      min={min}
      max={max || 1000000000}
      suffix={suffix}
      style={{ width: "100%" }}
    />
  );
};
